export const fontSizes = {
	eta: 16,
	theta: 18,
	iota: 20,
};
